package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class EntityMappingResponse(
    val id: String,
    @SerialName("entity_type") val entityType: String,
    @SerialName("legacy_entity_id") val legacyEntityId: String,
    @SerialName("catalog_entity_id") val catalogEntityId: String,
    @SerialName("match_confidence") val matchConfidence: String,
    @SerialName("match_method") val matchMethod: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("created_by") val createdBy: String? = null
)

@Serializable
data class CreateEntityMappingRequest(
    @SerialName("entity_type") val entityType: String,
    @SerialName("legacy_entity_id") val legacyEntityId: String,
    @SerialName("catalog_entity_id") val catalogEntityId: String
)

@Serializable
data class UnmatchedEntityResponse(
    @SerialName("legacy_id") val legacyId: String,
    @SerialName("name_ar") val nameAr: String? = null,
    @SerialName("name_en") val nameEn: String? = null,
    @SerialName("entity_type") val entityType: String
)

@Serializable
data class AutoMatchResponse(
    val matched: Int,
    @SerialName("already_mapped") val alreadyMapped: Int,
    val unmatched: Int,
    val details: List<String>
)
